import styled from '@emotion/styled'
import * as React from 'react'

type TProps = RequiredChildren

const StyledNumber = styled.span`
  font-feature-settings: 'tnum';
  font-variant-numeric: tabular-nums;
`

export const Number: React.FC<TProps> = ({ children }) => {
  return <StyledNumber>{children}</StyledNumber>
}
